import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {Actions as MessageActions} from '../../common/messageBox/actions';

import * as ActionTypes from './actionTypes';
import {cleanCommercialUsersReducer, fetchCommercialUsers} from './get';

export const setEditableRowIndex = (index) => {
  return {
    'type': ActionTypes.SET_EDITABLE_ROW_INDEX,
    'payload': index,
  };
};

export const updateCommercialUser = (id, newData) => {
  return {
    'type': ActionTypes.UPDATE_USER_DATA,
    'payload': {
      id,
      newData,
    },
  };
};

export const deleteCommercialUser = (id) => {
  return {
    'type': ActionTypes.DEACTIVATE_USER_ROW,
    'payload': {
      id,
    },
  };
};

export const sendCommercialUsersData = (data) =>
  (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': '/commercial/users',
        'authenticated': true,
        'types': [
          ActionTypes.SENDING_COMMERCIAL_USERS_DATA,
          [
            () => {
              dispatch(cleanCommercialUsersReducer());
              dispatch(fetchCommercialUsers());
              return {
                'type': ActionTypes.SENT_COMMERCIAL_USERS_DATA,
              };
            },
          ],
          [
            {
              'type': ActionTypes.SENT_COMMERCIAL_USERS_DATA_FAILED,
            },
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'POST',
        'contentType': 'application/json',
        data,
      }),
    );
  };

export const updateCommercialUsers = (data) =>
  (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': '/commercial/users/update',
        'authenticated': true,
        'types': [
          ActionTypes.SENDING_COMMERCIAL_USERS_UPDATE,
          [
            (result) => {
              if (result?.message !== 'Error') {
                dispatch(MessageActions.addMessageBoxInfo('La base de datos ha sido actualizada con éxito'));
              }
              return {
                'type': ActionTypes.SENT_COMMERCIAL_USERS_UPDATE,
              };
            },
          ],
          [
            {
              'type': ActionTypes.SENT_COMMERCIAL_USERS_UPDATE_FAILED,
            },
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'POST',
        'contentType': 'application/json',
        data,
      }),
    );
  };
